import { useEffect, useMemo, useRef, useState } from "react";
import {
  doc,
  onSnapshot,
  runTransaction,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { db } from "../firebaseConfig";

const DEFAULT_ENTITLEMENTS = {
  demoSongsLeft: 2,
  paidSongsCredits: 0,
  demoLyricsLeft: 7,
  paidLyricsCredits: 0,
  updatedAt: null,
};




export function useEntitlements(uid) {
  const [loading, setLoading] = useState(true);
  const [ent, setEnt] = useState(DEFAULT_ENTITLEMENTS);

  // evita re-intentar init muchas veces
  const initAttemptedRef = useRef(false);

useEffect(() => {
  // ✅ si no hay uid: no escuchamos firestore y dejamos defaults sin "loading"
  if (!uid) {
    setEnt(DEFAULT_ENTITLEMENTS);
    setLoading(false);
    initAttemptedRef.current = false;
    return;
  }

  const ref = doc(db, "usuarios", uid);

  const unsub = onSnapshot(
    ref,
    async (snap) => {
      const data = snap.data() || {};
      const e = data.entitlements;

      if (!e) {
        setEnt(DEFAULT_ENTITLEMENTS);
        setLoading(false);

        if (!initAttemptedRef.current) {
          initAttemptedRef.current = true;
          try {
            await setDoc(
              ref,
              { entitlements: { ...DEFAULT_ENTITLEMENTS, updatedAt: serverTimestamp() } },
              { merge: true }
            );
          } catch (err) {
            console.error("Init entitlements failed:", err);
          }
        }
        return;
      }

      setEnt({ ...DEFAULT_ENTITLEMENTS, ...e });
      setLoading(false);
    },
    (err) => {
      console.error("Entitlements snapshot error:", err);
      setLoading(false);
    }
  );

  return () => unsub();
}, [uid]);


 const computed = useMemo(() => {
  const demoSongsLeft = ent.demoSongsLeft || 0;
  const paidSongsCredits = ent.paidSongsCredits || 0;
  const demoLyricsLeft = ent.demoLyricsLeft || 0;
  const paidLyricsCredits = ent.paidLyricsCredits || 0;

  const canSong = demoSongsLeft > 0 || paidSongsCredits > 0;
  const canLyrics = demoLyricsLeft > 0 || paidLyricsCredits > 0;

  const songNextType = demoSongsLeft > 0 ? "demo" : paidSongsCredits > 0 ? "paid" : "none";
  const lyricsNextType = demoLyricsLeft > 0 ? "demo" : paidLyricsCredits > 0 ? "paid" : "none";

  // ✅ bloqueo descargas (solo paga desbloquea)
  const canDownloadSongs = !!ent.hasPaid; 

  return { canSong, canLyrics, songNextType, lyricsNextType, canDownloadSongs };
}, [ent]);

  async function consumeSongCredit() {
    if (!uid) throw new Error("NO_UID");

    const userRef = doc(db, "usuarios", uid);

    return await runTransaction(db, async (tx) => {
      const snap = await tx.get(userRef);
      const data = snap.data() || {};
      const e = { ...DEFAULT_ENTITLEMENTS, ...(data.entitlements || {}) };

      let used = "none";
      if ((e.demoSongsLeft || 0) > 0) {
        e.demoSongsLeft -= 1;
        used = "demo";
      } else if ((e.paidSongsCredits || 0) > 0) {
        e.paidSongsCredits -= 1;
        used = "paid";
      } else {
        throw new Error("NO_SONG_CREDITS");
      }

      tx.set(
        userRef,
        { entitlements: { ...e, updatedAt: serverTimestamp() } },
        { merge: true }
      );

      return { used };
    });
  }

  async function consumeLyricsCredit() {
    if (!uid) throw new Error("NO_UID");

    const userRef = doc(db, "usuarios", uid);

    return await runTransaction(db, async (tx) => {
      const snap = await tx.get(userRef);
      const data = snap.data() || {};
      const e = { ...DEFAULT_ENTITLEMENTS, ...(data.entitlements || {}) };

      let used = "none";
      if ((e.demoLyricsLeft || 0) > 0) {
        e.demoLyricsLeft -= 1;
        used = "demo";
      } else if ((e.paidLyricsCredits || 0) > 0) {
        e.paidLyricsCredits -= 1;
        used = "paid";
      } else {
        throw new Error("NO_LYRICS_CREDITS");
      }

      tx.set(
        userRef,
        { entitlements: { ...e, updatedAt: serverTimestamp() } },
        { merge: true }
      );

      return { used };
    });
  }

  return {
    loading,
    entitlements: ent,
    ...computed,
    consumeSongCredit,
    consumeLyricsCredit,
  };

  
}




//USO

//import { useEntitlements } from "../hooks/useEntitlements";

// ----------------- PARA LAS CANCIONES ----------------
//const {
//  loading: entLoading,
//  canSong,
//  consumeSongCredit,
//  entitlements
//} = useEntitlements(firebaseUser?.uid);

//En el handle
// if (!canSong) {
//      setError(t("limites.limiteAlcanzadoCancion"));
//      return;
//    }

// ✅ 1) Descontar crédito ANTES de crear la canción
// EN EL createHandle
//await consumeSongCredit();

//EN EL CATCH DE CREATE HANDLE
// // ✅ si falló por créditos
//    if (String(e?.message || "").includes("NO_SONG_CREDITS")) {
//      setError("Ya llegaste al límite. Realiza un pago para crear más canciones.");
//    } else {
//      setError(t("createSong.errors.generic"));
//    }

//DESHABILITAR EL BOTON
//<button
//  className="btn btn-primary"
//  disabled={saving || entLoading || !canSong}
//  onClick={handleCreateSong}
//>
//  {saving ? t("createSongWithLyrics.creatingButton") : t("createSongWithLyrics.createButton")}
//</button>


//MOSTRAR MENSAJE DEBAJO DEL BOTON
 //{!entLoading && !canSong ? (
 //   <div className="alert-error" style={{ marginTop: 10 }}>
 //     {t("limites.limiteAlcanzadoCancion")}
 //     
 //   </div>
 // ) : null}







// --------------- PARA LA LETRA ---------------
//const {
//  loading: entLoading,
//  canLyrics,
//  consumeLyricsCredit,
//  entitlements
//} = useEntitlements(firebaseUser?.uid);


//En el handle
// if (!canLyrics) {
//      setError(t("limites.limiteAlcanzadoLetra"));
//      return;
//    }

// ✅ 1) Descontar crédito ANTES de crear la canción
// EN EL createHandle
//await consumeLyricsCredit();

//EN EL CATCH DE CREATEHANDLE
// // ✅ si falló por créditos
//    if (String(e?.message || "").includes("NO_SONG_CREDITS")) {
//      setError("Ya llegaste al límite. Realiza un pago para crear más letras.");
//    } else {
//      setError(t("createSong.errors.generic"));
//    }

//DESHABILITAR EL BOTON
//<button
//  className="btn btn-primary"
//  disabled={generating || saving || entLoading || !canLyrics}
//  onClick={handleCreateLyrics}
//>
//   {saving ? t("createLyrics.savingButton") : t("createLyrics.saveButton")}
//</button>

//MOSTRAR MENSAJE DEBAJO DEL BOTON
//{!entLoading && !canLyrics ? (
//  <div className="alert-error" style={{ marginTop: 10 }}>
//    {t("limites.limiteAlcanzadoLetras")}
//  </div>
//) : null}


